/**
 * 入力値のバリデーションを行うUtilsです。
 */

/**
 * 必須チェック
 * @param {string} value 値
 * @returns {boolean} 空の場合：true
 */
export function isEmpty(value: string): boolean{
  return !!(value && value.trim() !== '');
};

/**
 * 半角英数字チェック
 * @param {string} value 値
 * @returns {boolean} 半角英数字の場合：true
 */
export function isHalfAlphanumeric(value: string): boolean {
  return /^[0-9a-zA-Z]*$/.test(value);
};

/**
 * 半角数字チェック
 * @param {string} value 値
 * @returns {boolean} 半角数字の場合：true
 */
export function isNumeric(value: string): boolean {
  return /^([0-9]\d*|)$/.test(value);
};

/**
* 小数ありの半角数字かチェック
* @param {string} value 値
* @returns {boolean} 半角数字の場合：true
*/
export function isDecimalDigits(value: string): boolean {
  return /^([1-9]\d*|0)(\.\d+)?$/.test(value);
};

/**
* 小数ありの半角数字が小数第二位までかチェック
* @param {string} value 値
* @returns {boolean} 半角数字の場合：true
*/
export function isTwoDecimalNumeric(value: string): boolean {
  return /^([1-9]\d{0,3}|0)(\.[0-9]{0,2})?$/.test(value);
};

/**
 * 半角カナチェック
 * @param {string} value 値
 * @returns {boolean} 半角カナの場合：true
 */
export function isHalfKana(value: string): boolean {
  return /[ｱ-ﾝﾞﾟ]+/.test(value);
};

/**
 * メールアドレス形式チェック
 * @param {string} value 入力値
 * @returns {boolean} メールアドレス形式に誤りがある場合：true
 */
export function isValidateEmail(value: string): boolean {
  return  /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(value);
};

/**
 * 半角英数記号チェック
 * @param {string} value 値
 * @returns {boolean} 半角英数字の場合：true
 */
export function isHalfAlphanumericsymbol(value: string): boolean {
  return /^[a-zA-Z0-9!-/\s:-@¥\\[-`{-~]*$/.test(value);
};

/**
 * 小数部2桁以内で入力されていることをチェック
 * @param {string} value 値
 * @returns {boolean} 小数部2桁以内の場合：true
 */
export function isTwoDecimalPlaces(value: string): boolean {
  return /^([0-9][0-9]{0,}|0)(\.[0-9]{1,2})?$/.test(value);
};

/**
 * 3ケタごとにカンマ区切りの数列(金額)チェック
 * @param {string} value 値
 * @returns {boolean} 3ケタごとにカンマ区切りの数列の場合：true
 */
export function isMoneyType(value: string): boolean {
  return /^[1-9]([0-9]{0,2})((,\d{3})*\b)$/.test(value);
};
